const numberOfAddressesToShow = 3;

const getDeepLinkAccount = (domain) => `meli://webview/?url=https://${domain}/profile/addresses/all`;

module.exports = { numberOfAddressesToShow, getDeepLinkAccount };
